import { API_NAME, DEFAULT_ERROR_MESSAGE } from '../../const';
import API from '@aws-amplify/api'
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

export async function fetchApplyDetails(id: string) {
  await checkCurrentAuthenticatedUser()
  const response = await API.get(API_NAME, `/v2/` + id, {}).catch((err) => {
    alert(DEFAULT_ERROR_MESSAGE);
    throw err;
  });
  return response.record_found ? response.record[0] : {};
}
